<template>
  <div class="tables">
    <div>
      <h6>昵称/用户名</h6>
      <p><span>使用目的</span> <span>用于完善网络身份标识</span></p>
      <p><span>使用场景</span> <span>用于个人主页的个性化信息展示</span></p>
      <p>
        <span>收集情况</span> <span>{{ user.nickName!== '-' ? "用户提供，已收集1条" : "未收集" }}</span>
      </p>
      <p>
        <span>信息内容</span> <span>{{ user.nickName}}</span>
      </p>
    </div>
    <div>
      <h6>手机号码</h6>
      <p><span>使用目的</span> <span>用于注册创建账号和登录</span></p>
      <p><span>使用场景</span> <span>用户注册、登录及实名认证</span></p>
      <p>
        <span>收集情况</span> <span>{{ user.phone!== '-' ? "用户提供，已收集1条" : "未收集" }}</span>
      </p>
      <p>
        <span>信息内容</span> <span>{{ user.phone}}</span>
      </p>
    </div>
    <div>
      <h6>头像</h6>
      <p><span>使用目的</span> <span>用于展示头像信息</span></p>
      <p><span>使用场景</span> <span>用于个人主页的个性化信息展示</span></p>
      <p>
        <span>收集情况</span> <span>{{ user.headpic!== '-' ? "用户提供，已收集1条" : "未收集" }}</span>
      </p>
      <p>
        <span>信息内容</span> 
        <span v-if="user.headpic">
          <img style="width:80px;height:80px" :src="imgPrex + user.headpic" alt="">
          
        </span>
        <span v-else>--</span>
      </p>
    </div>
    <div>
      <h6>第三方账号</h6>
      <p><span>使用目的</span> <span>用于使用第三方账号授权登录</span></p>
      <p><span>使用场景</span> <span>用户使用第三方账号登录</span></p>
      <p>
        <span>收集情况</span> <span>{{ user.hadBindWX!== '-' ? "用户提供，已收集1条" : "未收集" }}</span>
      </p>
      <p>
        <span>信息内容</span> <span>{{ user.hadBindWX}}</span>
      </p>
    </div>
  </div>
</template>

<script>
import { getUserInfo } from "@/api/expert";
export default {
  data() {
    return {
      user: {},
    };
  },
  mounted() {
    this._getUserInfo()
  },
  methods: {
    async _getUserInfo(){
        const res = await getUserInfo({});
        if(res.appStatus.errorCode == 0){
            this.user = {...res.content}
        }
    }
  },
};
</script>

<style lang="scss" scoped>
.tables {
  margin: 10px;
  padding-bottom: 30px;
  > div {
    margin-top: 20px;
    background: #d9d9d9;
    h6 {
      background: #fff;
    }
    p {
      font-size: 14px;
      display: flex;
      line-height: 30px;
      span:first-child {
        background: #d9d9d9;
        width: 100px;
        text-align: center;
      }
      span:last-child {
        width: 100%;
        display: block;
        background: #fff;
        border: 1px solid #d9d9d9;
        text-align: center;
      }
    }
  }
}
</style>
